import { Component, input, output, signal } from "@angular/core";

import { LanguageDisplayNamePipe } from "@dcc/shared/ui-pipes";
import { locales } from "@dcc/shared/util-locale-manager";
import { VdsIconButtonComponent } from "@dcc/vestas-design-system/angular/components/button";
import { VdsIconComponent } from "@dcc/vestas-design-system/angular/components/icon";
import { VdsMenu, VdsMenuItemRadio, VdsMenuTrigger } from "@dcc/vestas-design-system/angular/components/menu";
import { VdsTooltipDirective } from "@dcc/vestas-design-system/angular/components/tooltip";

@Component({
    selector: "shell-ui-language-menu",
    templateUrl: "./language-menu.component.html",
    host: {
        class: "block"
    },
    imports: [
        VdsMenu,
        VdsMenuTrigger,
        VdsMenuItemRadio,
        VdsIconButtonComponent,
        VdsIconComponent,
        LanguageDisplayNamePipe,
        VdsTooltipDirective
    ]
})
export class LanguageMenuComponent {
    public readonly locales = signal(locales);

    public language = input.required<string>();
    public triggerLabel = input<string>();

    public languageChange = output<{ id: string; value: string }>();
}
